import { Box, Typography, Pagination } from "@mui/material";

export default function PaginationWithInfo({
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  isLoading = false,
}) {
  const start = page * rowsPerPage + 1;
  const end = Math.min((page + 1) * rowsPerPage, totalCount);
  const totalPages = Math.ceil(totalCount / rowsPerPage);

  return (
    <Box
        sx={{
            position: "relative", // 🔥 핵심! absolute의 기준이 될 부모
            height: 48,            // 높이 고정
            borderTop: "1px solid #e0e0e0",
            backgroundColor: "#fff",
            zIndex: 3,
            opacity: isLoading ? 0.5 : 1, 
            pointerEvents: isLoading ? "none" : "auto", 
            transition: "opacity 0.2s",
            width: "800px"
        }}
        >
        {/* 왼쪽 텍스트 블럭 */}
        <Box
            sx={{
            position: "absolute",
            left: 24,
            top: "50%",
            transform: "translateY(-50%)",
            display: "flex",
            alignItems: "center",
            gap: 0.2,
            }}
        >
            <Typography
            variant="body2"
            sx={{ fontSize: "10px", fontWeight: 500, color: "#444" }}
            >
            총 상품 수
            </Typography>
            <Typography
            variant="body1"
            fontWeight="bold"
            sx={{
                fontSize: "10px",
                color: "#000",
                backgroundColor: "#e3f2fd",
                px: 1,
                py: 0.3,
                borderRadius: 1,
            }}
            >
            {totalCount.toLocaleString()}개
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "10px", fontWeight: 500, color: "#444" }}>
            표시 범위
            </Typography>
            <Box
            sx={{
                backgroundColor: "#e3f2fd",
                borderRadius: 1,
                px: 1.2,
                py: 0.3,
                fontWeight: 600,
                fontSize: "10px",
                color: "#1976d2",
            }}
            >
            {start}–{end}개
            </Box>
        </Box>

        {/* 중앙 페이지네이션 */}
        <Box
            sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            top: "50%",
            transformOrigin: "center",
            translate: "0 -50%",
            }}
        >
            <Pagination
                count={totalPages}
                page={page + 1}
                onChange={(_, newPage) => onPageChange(newPage - 1)}
                color="primary"
                size="small"
                sx={{
                    '& .MuiPaginationItem-root': {
                      fontSize: "9px", // 글자 크기 여기 조정
                    }
                  }}
            />
        </Box>
        </Box>

  );
}